import React from 'react';
const ReusableHtmlRenderer = (props) => {
    const { children, } = props;
    return (React.createElement("div", null, children));
};
export default ReusableHtmlRenderer;
//# sourceMappingURL=ReusableHtmlRenderer.js.map